/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Table, Form, Typography, Space, Col, Row, Grid,
} from 'antd';

const { Column } = Table;
const { Text } = Typography;

const defaultRowStyle = {
  justify: 'start',
  gutter: {
    xs: 8, sm: 16, md: 24, lg: 32,
  },
  style: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },
};
const defaultColStyle = {
  xs: {
    span: 12,
  },
  sm: {
    span: 12,
  },
};

const simpleRowStyle = {
  justify: 'start',
  gutter: {
    xs: 8, sm: 16, md: 24, lg: 32,
  },
  style: {
    paddingLeft: '5%',
    paddingRight: '5%',
  },
};

const { useBreakpoint } = Grid;

function EPRDetailSection({
  data: {
    details,
  },
  fields: {
    Subcategory3Field,
    LocationField,
    ProductField,
    DescriptionField,
    ProjectField,
    ChargeCostCenterField,
    NetAmountField,
    VatableField,
    WithEwtField,
    TotalAmountField,
    OpexCapexDropdownField,
  },
  buttons: {
    AddButton,
    DeleteButton,
    MoreInfoButton,
  },
}) {
  const screen = useBreakpoint();
  const [rowStyle, setRowStyle] = useState(defaultRowStyle);
  const [colStyle] = useState(defaultColStyle);

  useEffect(() => {
    if (screen.xs) {
      setRowStyle((currRowStyle) => ({
        ...currRowStyle,
        style: {
          paddingLeft: '2%',
          paddingRight: '2%',
        },
      }));
      return;
    }
    setRowStyle(defaultRowStyle);
  }, [screen]);

  const summarySection = () => (
    <>
      <Table.Summary.Row>
        <Table.Summary.Cell>
          <AddButton />
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          <Text style={{ float: 'right' }}>
            Total Amount
          </Text>
        </Table.Summary.Cell>
        <Table.Summary.Cell>
          {' '}
          {TotalAmountField()}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    </>
  );

  const lineItemColumn = () => (
    <Column
      title="Line Item"
      dataIndex="line_item"
      key="record_id"
      width="10%"
      render={(text, record) => (
        <Text style={{ textAlign: 'center' }}>{details.indexOf(record) + 1}</Text>)}
    />
  );

  const itemForm = ({ record }) => (
    <>
      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="subcategory3"
            label="Sub Category 3"
          >
            {Subcategory3Field({ record })}
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="description"
            label="Description"
          >
            {DescriptionField({ record })}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="location"
            label="Location"
          >
            {LocationField({ record })}
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="product"
            label="Product"
          >
            {ProductField({ record })}
          </Form.Item>
        </Col>
      </Row>
      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="project"
            label="Project"
          >
            {ProjectField({ record })}
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="chargecostcenter"
            label="Charge Cost Center"
          >
            {ChargeCostCenterField({ record })}
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="OpexCapex"
            label="Opex/Capex/Cogs"
          >
            {OpexCapexDropdownField({ record })}
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="netAmount"
            label="Net Amount"
          >
            {NetAmountField({ record })}
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Row {...simpleRowStyle}>
            <Col>
              <Form.Item
                name="vatable"
                label="Vatable"
              >
                {VatableField({ record })}
              </Form.Item>
            </Col>
            <Col>
              <Form.Item
                name="withewt"
                label="With EWT"
              >
                {WithEwtField({ record })}
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col {...colStyle} />
      </Row>
    </>

  );

  const itemColumn = () => (
    <Column
      title="Item"
      dataIndex="item"
      key="item"
      width="70%"
      render={(text, record) => itemForm({ record })}
    />
  );

  const actionColumn = () => (
    <Column
      title="Action"
      key="action"
      width="20%"
      render={(text, record) => (
        <>
          <Space>
            <MoreInfoButton record={record} />
            <DeleteButton record={record} />
          </Space>
        </>
      )}
    />
  );

  return (
    <Form.Item wrapperCol={{ span: 24 }}>
      <Table
        style={{ paddingLeft: '70px', paddingRight: '70px' }}
        dataSource={details}
        pagination={false}
        summary={summarySection}
      >
        {lineItemColumn()}
        {itemColumn()}
        {actionColumn()}
      </Table>
    </Form.Item>
  );
}

export default EPRDetailSection;
